import { useNode } from "@craftjs/core";
import React, { useContext, useEffect } from "react";
import GrigoraCSSRenderer from "./../css-render";
import { PostTimeToReadSettings } from "./settings";
import icon from "./icon";
import classnames from "classnames";
import { getDynamicCSS, getSupportProps } from "../../block-supports";
import { GrigoraDashboardContext } from "../../dashboard/context";

export const PostTimeToRead = (props) => {
  const { cmsPosts } = useContext(GrigoraDashboardContext) ?? {};
  const {
    id,
    connectors: { connect, drag },
    selected,
  } = useNode((state) => ({
    id: state.id,
    selected: state.events.selected,
    dragged: state.events.dragged,
  }));

  const {
    units = "M",
    prefix,
    suffix = "min read",
    readingSpeed = 183,
  } = props;

  var blockProps = getSupportProps({
    id,
    ...props,
  });

  const wrapperClass = classnames(
    {
      "g-post-time-to-read": true,
      [`post-time-to-read-${id}`]: id,
    },
    blockProps.className,
  );

  useEffect(() => {
    if (selected) {
      return;
    }
  }, [selected]);

  var timeToRead;
  if (cmsPosts?.[0]?.word_count) {
    switch (units) {
      case "M":
        timeToRead = Math.ceil(
          Number(cmsPosts?.[0]?.word_count) / readingSpeed,
        );
        break;

      case "h":
        timeToRead = Math.ceil(
          Number(cmsPosts?.[0]?.word_count) / readingSpeed / 60,
        );
        break;

      case "s":
        timeToRead = Math.ceil(
          (Number(cmsPosts?.[0]?.word_count) / readingSpeed) * 60,
        );
        break;
    }
  }

  return (
    <div
      {...blockProps}
      ref={(ref) => connect(drag(ref))}
      onClick={() => selected}
      className={wrapperClass}
      data-grigora-block="true"
      data-grigora-block-id={id}
    >
      <style>{`${getDynamicCSS(id, props)}`}</style>
      <style>{`${GrigoraCSSRenderer.blockCSS__PostTimeToRead(
        id,
        props,
      )}`}</style>
      <span className="prefix">{prefix && prefix}</span> &nbsp;
      <p className="post-time-paragraph">{timeToRead}</p> &nbsp;
      <span className="suffix">{suffix && suffix}</span>
    </div>
  );
};

// To Avoid Mangling in Production
PostTimeToRead.displayName = "PostTimeToRead";

PostTimeToRead.craft = {
  name: "Post Time To Read",
  props: {},
  related: {
    settings: PostTimeToReadSettings,
    icon: icon,
    supports: [
      "grigora/entrance-animations",
      "grigora/css-transform-animations",
      "grigora/mouse-movement",
      "grigora/visibility",
      "grigora/position",
      "grigora/sticky",
      "grigora/filter",
      "grigora/custom-class",
      "grigora/custom-id",
    ],
    category: "cms",
  },
  custom: {
    name: "Post Time To Read",
    slug: "grigora/post-time-to-read",
  },
};
